"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'profession.search.placeholder': '搜索职业...',
};
